
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.542","height":"12.393"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.217 11.221a5.445 5.445 0 01-5.959-1.185 5.48 5.48 0 01-.066-7.79 5.574 5.574 0 017.844-.066 5.776 5.776 0 011.622 3.3","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M8.7 4.734l2.863 1.234a.468.468 0 00.615-.24l1.236-2.868","fill":"none","stroke":"#727998","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.1997479999999998"}})])
          )
        }
      }
    